module.exports = __webpack_public_path__ + "img/ydd_downLoad2.0ed933bb.png";